import { ModelType } from '@biteinc/enums';

app.OrgToolsView = app.BaseToolsView.extend({
  _renderOrderSearchView() {
    this._orderSearchView = new app.SearchView({
      title: 'Find Order',
      placeholder: 'enter mongoId, phone number, or email',
      url: '/api/v2/orders/search',
      Model: app.Order,
      patterns: [
        { regex: app.SearchView.MongoIdRegEx, searchParam: 'query' },
        {
          regex: new RegExp(/^([a-z0-9_\-.]+)@([a-z0-9_\-.]+)\.([a-z]{2,5})$/i),
          searchParam: 'query',
        },
        { regex: new RegExp(/^\d{10}$/), searchParam: 'query' },
      ],
      parseResults(data) {
        return (data.orders || []).map((order) => {
          const location = app.locationList.get(order.locationId);
          const url = location
            ? `${window.location.origin}/${location.attributes.orgNormalizedName}/` +
              `${location.attributes.normalizedName}/${location.attributes.orderChannel}` +
              `#orders/${order._id}`
            : undefined;
          return { modelType: ModelType.Order, data: order, url };
        });
      },
    });
    this.$el.append(this._orderSearchView.render().$el);
  },

  _isPreviewHost() {
    try {
      const hostname = window.location.hostname || '';
      return /^pr-\d+-/i.test(hostname);
    } catch {
      return false;
    }
  },

  _loadPreviewOrgDataClicked(event) {
    const $button = $(event.target);
    const detailsView = new app.SchemaDetailsView({
      title: 'Load Org Data into Preview',
      saveButtonTitles: ['Load', 'Loading...', 'Done!'],
      subProperty: 'options',
      schema: {
        type: 'object',
        fields: {
          syncLastOrderDayCount: {
            displayName: 'Sync last order day count',
            type: 'int',
            required: true,
            min: 0,
            max: 10,
            defaultValue: 0,
          },
        },
      },
      callback(model) {
        const opts = model.options || {};
        const rawSyncLastOrderDayCount = Math.trunc(Number(opts.syncLastOrderDayCount));
        const syncLastOrderDayCount = Number.isFinite(rawSyncLastOrderDayCount)
          ? Math.min(10, Math.max(0, rawSyncLastOrderDayCount))
          : 0;

        const reqId = $button.initLoadingButton($button.html(), 'Loading...', 'Loaded!');
        const url = '/api/v2/internal-tools/load-preview-org-data';
        app.makeRequest(
          'POST',
          url,
          {
            orgId: app.org.id,
            syncLastOrderDayCount,
          },
          () => {
            $button.loadingDidFinishSuccessfully(reqId);
            new app.AlertView().show('Data load started/completed.');
          },
          () => {
            $button.loadingDidFinishWithError(reqId);
          },
        );
      },
    });
    app.modalManager.showModalWithView(detailsView);
  },

  _deleteOrgButtonWasClicked(event) {
    if (!window.confirm('Are you sure you want to delete this org?')) {
      return;
    }

    const $button = $(event.target);
    const reqId = $button.initLoadingButton($button.html(), 'Deleting', 'Deleted');
    app.org.destroy({
      error() {
        $button.loadingDidFinishWithError(reqId);
      },
      success(data) {
        $button.loadingDidFinishSuccessfully(reqId);
        const message = data.status || 'Deleted this org!';
        app.showSavedToastAndReload(message);
        setTimeout(() => {
          window.location = '/';
        }, 1500);
      },
    });
  },

  _invalidateMenuCachesWasClicked(event) {
    if (
      !window.confirm(
        'Are you sure you want to invalidate the menu caches of all channels in the org?',
      )
    ) {
      return;
    }

    const $button = $(event.target);
    const reqId = $button.initLoadingButton($button.html(), 'Invalidating', 'Invalidated');
    app.org.refreshMenuCaches({
      error() {
        $button.loadingDidFinishWithError(reqId);
      },
      success() {
        $button.loadingDidFinishSuccessfully(reqId);
        app.showSavedToastAndReload('Caches are clear!', true);
      },
    });
  },

  _removeArchiveButtonWasClicked(event) {
    const confirmed = app.promptUserToTypeInConfirmation(
      `Please type in "Delete the Archive" to confirm that you want to delete ALL archived menu items, sections, mods, and mod groups ACROSS ALL LOCATIONS in this org.`,
      'Delete the Archive',
    );
    if (!confirmed) {
      return;
    }

    const $button = $(event.target);
    const reqId = $button.initLoadingButton($button.html(), 'Removing', 'Removed');
    app.org.removeArchive({
      error() {
        $button.loadingDidFinishWithError(reqId);
      },
      success() {
        $button.loadingDidFinishSuccessfully(reqId);
        app.showSavedToastAndReload('Removed menu archive!', true);
      },
    });
  },

  _importKiosksFromCsvClicked() {
    app.modalManager.showModalWithView(new app.KioskImportModal());
  },

  render() {
    app.BaseToolsView.prototype.render.apply(this, arguments);

    this._renderOrderSearchView();

    this.addToolbarButton(
      'btn-danger',
      'Invalidate Menu Caches',
      this._invalidateMenuCachesWasClicked.bind(this),
    );

    if (app.sessionUser.isBiteEng() && this._isPreviewHost()) {
      this.addToolbarButton(
        'btn-primary',
        'Load Preview Org Data ⚙',
        this._loadPreviewOrgDataClicked.bind(this),
      );
    }

    if (app.sessionUser.isBiteOps()) {
      this.addToolbarButton(
        'btn-primary',
        'Import Kiosks from CSV ⚒',
        this._importKiosksFromCsvClicked.bind(this),
      );

      this.addToolbarButton(
        'btn-danger',
        '🗑 Remove Archived Menu Things',
        this._removeArchiveButtonWasClicked.bind(this),
      );

      this.addToolbarButton(
        'btn-danger',
        'Delete This Org',
        this._deleteOrgButtonWasClicked.bind(this),
      );
    }

    return this;
  },
});
